/**
 * Friday lockup — the wordmark on a title plate.
 *
 * The mark itself is the themed `FridayMark`, which reads each theme's
 * --brand-stroke / --brand-fill. Every theme therefore keeps its own logo
 * (Blade Runner's red-and-amber, Cyberpunk's cyan, Balatro's blue, and so
 * on); only OG Friday dresses it as the landing page's title card — solid
 * ink on cream paper with a rust offset shadow.
 */

import { cn } from '@/lib/utils'
import { FridayMark } from './FridayMark'

interface FridayLockupProps {
  size?: 'sm' | 'md'
  className?: string
}

export function FridayLockup({ size = 'md', className }: FridayLockupProps) {
  return (
    <span className={cn('friday-lockup', size === 'sm' && 'friday-lockup--sm', className)}>
      <FridayMark size={size === 'sm' ? 22 : 28} title="Friday" />
    </span>
  )
}
